import { CreateAllTrainingOrdersResponse } from '@aloft/toolkit-shared';
import { useQueryClient } from '@tanstack/react-query';

import {
  useCreateAllTrainingOrdersAPI,
  usePostVacantLandSales,
} from '../../../hooks/api/toolkitComponents.js';
import { useToolkitContext } from '../../../hooks/api/toolkitContext.js';

let hasCreatedOrders = false;

export function useCreateAllTrainingOrders(
  archived: boolean,
): () => Promise<CreateAllTrainingOrdersResponse> {
  const { queryKeyFn } = useToolkitContext();
  const createAllTrainingOrdersQuery = useCreateAllTrainingOrdersAPI({});
  const postVacantLandSales = usePostVacantLandSales();
  const queryClient = useQueryClient();

  return async (): Promise<CreateAllTrainingOrdersResponse> => {
    try {
      if (hasCreatedOrders) {
        return [];
      }

      hasCreatedOrders = true;

      const res = await createAllTrainingOrdersQuery.mutateAsync({ body: { archived } });

      res.forEach((orderID: string) => {
        postVacantLandSales.mutate(
          {
            pathParams: {
              orderID,
            },
          },
          {
            onSuccess: () => {
              // Refresh vacant land sales on success
              queryClient.refetchQueries({
                queryKey: queryKeyFn({
                  operationId: 'getVacantLandSales',
                  path: '/api/v2/orders/{orderID}/attachments/vacantLandSales',
                  variables: {
                    pathParams: {
                      orderID,
                    },
                  },
                }),
              });
            },
          },
        );
      });

      return res as string[];
    } catch (err) {
      console.error(err);
      return [];
    }
  };
}
